module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"tables_to_compute":"Liste of chosen tables to compute"},"fr":{"tables_to_compute":"Liste des tables à calculer"}}')
  delete Component.options._Ctor
}
